import React from 'react'
import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'

interface MiniLoaderProps {
  size?: number
  fill?: 'light' | 'dark'
  paddingLeft?: number
  paddingRight?: number
}

/**
 * Mini loader with spinner for rendering within a parent component such as a button
 */
export const MiniLoader: React.FC<MiniLoaderProps> = ({ size = 16, fill = 'light', paddingLeft, paddingRight }) => {
  return (
    <Box sx={{ display: 'flex' }} paddingLeft={paddingLeft} paddingRight={paddingRight || 2}>
      <CircularProgress size={size} sx={{ color: (theme) => fill === 'dark' ? theme.palette.custom.blue : theme.palette.custom.white }} />
    </Box>
  )
}
